<template>
    <div class="wrapper">
        <div class="nav"><img src="https://images.yitushijie.com/btn_nav_JianTou@2x.png" @click="back">{{type == 'i' ? '疾病' : '药品'}}</div>
        <div class="content" v-if="type == 'med'">
            <div class="btitle">{{medData.type2}}</div>
            <div class="contentBox" style="margin-bottom: 40rpx;">
                <div v-if="medData.type1 != ''">
                    <div class="stitle">序号</div>
                    <!-- <template is="wxParse" data="{{wxParseData:type1.nodes" /> -->
                    <div>{{medData.type1}}</div>
                </div>

                <div v-if="medData.type2 != ''">
                    <div class="stitle">药品名称，通用名称</div>
                    <div>{{medData.type2}}</div>
                </div>

                <div v-if="medData.type3 != ''">
                    <div class="stitle">类别</div>
                    <div>{{medData.type3}}</div>
                </div>

                <div v-if="medData.type4 != ''">
                    <div class="stitle">化学名称，其化学名为</div>
                    <div>{{medData.type4}}</div>
                </div>

                <div v-if="medData.type5 != ''">
                    <div class="stitle">拉丁名</div>
                    <div>{{medData.type5}}</div>
                </div>

                <div v-if="medData.type6 != ''">
                    <div class="stitle">拼音名</div>
                    <div>{{medData.type6}}</div>
                </div>

                <div v-if="medData.type7 != ''">
                    <div class="stitle">别名</div>
                    <div>{{medData.type7}}</div>
                </div>

                <div v-if="medData.type8 != ''">
                    <div class="stitle">适应症，功能主治</div>
                    <div>{{medData.type8}}</div>
                </div>

                <div v-if="medData.type9 != ''">
                    <div class="stitle">用法用量，服用方法</div>
                    <div>{{medData.type9}}</div>
                </div>

                <div v-if="medData.type10 != ''">
                    <div class="stitle">规格</div>
                    <div>{{medData.type10}}</div>
                </div>

                <div v-if="medData.type11 != ''">
                    <div class="stitle">核准日期</div>
                    <div>{{medData.type11}}</div>
                </div>

                <div v-if="medData.type12 != ''">
                    <div class="stitle">贮藏，贮法，收藏</div>
                    <div>{{medData.type12}}</div>
                </div>

                <div v-if="medData.type13 != ''">
                    <div class="stitle">性状</div>
                    <div>{{medData.type13}}</div>
                </div>

                <div v-if="medData.type14 != ''">
                    <div class="stitle">分子式，分子量</div>
                    <div>{{medData.type14}}</div>
                </div>

                <div v-if="medData.type15 != ''">
                    <div class="stitle">执行标准</div>
                    <div>{{medData.type15}}</div>
                </div>

                <div v-if="medData.type16 != ''">
                    <div class="stitle">结果判定</div>
                    <div>{{medData.type16}}</div>
                </div>

                <div v-if="medData.type17 != ''">
                    <div class="stitle">临床研究</div>
                    <div>{{medData.type17}}</div>
                </div>

                <div v-if="medData.type18 != ''">
                    <div class="stitle">禁忌</div>
                    <div>{{medData.type18}}</div>
                </div>

                <div v-if="medData.type19 != ''">
                    <div class="stitle">化学结构式，分子式</div>
                    <div>{{medData.type19}}</div>
                </div>

                <div v-if="medData.type20 != ''">
                    <div class="stitle">药品毒理，药理毒理</div>
                    <div>{{medData.type20}}</div>
                </div>

                <div v-if="medData.type21 != ''">
                    <div class="stitle">成份</div>
                    <div>{{medData.type21}}</div>
                </div>

                <div v-if="medData.type22 != ''">
                    <div class="stitle">作用类别</div>
                    <div>{{medData.type22}}</div>
                </div>

                <div v-if="medData.type23 != ''">
                    <div class="stitle">肥胖病人用药</div>
                    <div>{{medData.type23}}</div>
                </div>

                <div v-if="medData.type24 != ''">
                    <div class="stitle">药物相互作用</div>
                    <div>{{medData.type24}}</div>
                </div>

                <div v-if="medData.type25 != ''">
                    <div class="stitle">药物过量</div>
                    <div>{{medData.type25}}</div>
                </div>

                <div v-if="medData.type26 != ''">
                    <div class="stitle">儿童用药</div>
                    <div>{{medData.type26}}</div>
                </div>

                <div v-if="medData.type27 != ''">
                    <div class="stitle">不良反应</div>
                    <div>{{medData.type27}}</div>
                </div>

                <div v-if="medData.type28 != ''">
                    <div class="stitle">注意事项</div>
                    <div>{{medData.type28}}</div>
                </div>

                <div v-if="medData.type29 != ''">
                    <div class="stitle">药理作用</div>
                    <div>{{medData.type29}}</div>
                </div>

                <div v-if="medData.type30 != ''">
                    <div class="stitle">药代动力学</div>
                    <div>{{medData.type30}}</div>
                </div>

                <div v-if="medData.type31 != ''">
                    <div class="stitle">临床试验</div>
                    <div>{{medData.type31}}</div>
                </div>

                <div v-if="medData.type32 != ''">
                    <div class="stitle">警告，警示语</div>
                    <div>{{medData.type32}}</div>
                </div>

                <div v-if="medData.type33 != ''">
                    <div class="stitle">老年用药</div>
                    <div>{{medData.type33}}</div>
                </div>

                <div v-if="medData.type34 != ''">
                    <div class="stitle">脯乳期分级</div>
                    <div>{{medData.type34}}</div>
                </div>

                <div v-if="medData.type35 != ''">
                    <div class="stitle">妊娠分级</div>
                    <div>{{medData.type35}}</div>
                </div>

                <div v-if="medData.type36 != ''">
                    <div class="stitle">孕妇及哺乳期妇女用药</div>
                    <div>{{medData.type36}}</div>
                </div>

                <div v-if="medData.type37 != ''">
                    <div class="stitle">辅料</div>
                    <div>{{medData.type37}}</div>
                </div>

                <div v-if="medData.type38 != ''">
                    <div class="stitle">古籍（中）</div>
                    <div>{{medData.type38}}</div>
                </div>

                <div v-if="medData.type39 != ''">
                    <div class="stitle">产地（中）</div>
                    <div>{{medData.type39}}</div>
                </div>

                <div v-if="medData.type40 != ''">
                    <div class="stitle">处理（中）</div>
                    <div>{{medData.type40}}</div>
                </div>

                <div v-if="medData.type41 != ''">
                    <div class="stitle">归经（中）</div>
                    <div>{{medData.type41}}</div>
                </div>

                <div v-if="medData.type42 != ''">
                    <div class="stitle">古文简介（中）</div>
                    <div>{{medData.type42}}</div>
                </div>

                <div v-if="medData.type43 != ''">
                    <div class="stitle">来源（中）</div>
                    <div>{{medData.type43}}</div>
                </div>

                <div v-if="medData.type44 != ''">
                    <div class="stitle">属性（中）</div>
                    <div>{{medData.type44}}</div>
                </div>

                <div v-if="medData.type45 != ''">
                    <div class="stitle">评价（中）</div>
                    <div>{{medData.type45}}</div>
                </div>

                <div v-if="medData.type46 != ''">
                    <div class="stitle">鉴别（中）</div>
                    <div>{{medData.type46}}</div>
                </div>

                <div v-if="medData.type47 != ''">
                    <div class="stitle">注册名称</div>
                    <div>{{medData.type47}}</div>
                </div>

                <div v-if="medData.type48 != ''">
                    <div class="stitle">酸根</div>
                    <div>{{medData.type48}}</div>
                </div>

                <div v-if="medData.type49 != ''">
                    <div class="stitle">盐基</div>
                    <div>{{medData.type49}}</div>
                </div>

                <div v-if="medData.type50 != ''">
                    <div class="stitle">编码</div>
                    <div>{{medData.type50}}</div>
                </div>

                <div v-if="medData.type51 != ''">
                    <div class="stitle">医保类型</div>
                    <div>{{medData.type51}}</div>
                </div>

                <div v-if="medData.type52 != ''">
                    <div class="stitle">助记码</div>
                    <div>{{medData.type52}}</div>
                </div>

                <div v-if="medData.type53 != ''">
                    <div class="stitle">英文</div>
                    <div>{{medData.type53}}</div>
                </div>
            </div>
        </div>
        <div class="content" v-if="type == 'i'">
            <div class="btitle"  v-html="bodyData.IcdName">{{bodyData.IcdName}}</div>
            <div id="zero" class="contentBox" v-if="bodyData.Description != '' || bodyData.Classify != '' || bodyData.Parting != ''">
                <div class="title">疾病概述</div>
                <div class="stitle" v-if="bodyData.Description != ''">概述</div>
                <div v-html="bodyData.Description" v-if="bodyData.Description != ''"></div>
                <div class="stitle" v-if="bodyData.Classify != ''">分类</div>
                <div v-if="bodyData.Classify != ''" v-html="bodyData.Classify">{{bodyData.Classify}}</div>
                <div class="stitle" v-if="bodyData.Parting != ''">分型</div>
                <div v-if="bodyData.Parting != ''" v-html="bodyData.Parting">{{bodyData.Parting}}</div>
            </div>

            <div id="one" class="contentBox" v-if="bodyData.DiagnosisTreatmentSpecification != '' || bodyData.PreHospitalFirstAid != ''">
                <div class="title">处理原则</div>
                <div class="stitle" v-if="bodyData.DiagnosisTreatmentSpecification != ''">诊疗规范</div>
                <div v-if="bodyData.DiagnosisTreatmentSpecification != ''" v-html="bodyData.DiagnosisTreatmentSpecification">{{bodyData.DiagnosisTreatmentSpecification}}</div>
                <div class="stitle" v-if="bodyData.PreHospitalFirstAid != ''">院前急救</div>
                <div v-if="bodyData.PreHospitalFirstAid != ''" v-html="bodyData.PreHospitalFirstAid">{{bodyData.PreHospitalFirstAid}}</div>
            </div>

            <div id="two" class="contentBox" v-if="bodyData.Morphology != '' || bodyData.Physics != '' || bodyData.Pathophysiology != ''">
                <div class="title">正常与患病对比</div>
                <div class="stitle" v-if="bodyData.Morphology != ''">形态学对比</div>
                <div v-if="bodyData.Morphology != ''" v-html="bodyData.Morphology">{{bodyData.Morphology}}</div>
                <div class="stitle" v-if="bodyData.Physics != ''">物理学对比</div>
                <div v-if="bodyData.Physics != ''" v-html="bodyData.Physics">{{bodyData.Physics}}</div>
                <div class="stitle" v-if="bodyData.Pathophysiology != ''">病理生理学对比</div>
                <div v-if="bodyData.Pathophysiology != ''" v-html="bodyData.Pathophysiology">{{bodyData.Pathophysiology}}</div>
            </div>

            <div id="three" class="contentBox" v-if="bodyData.EtiPath != '' || bodyData.Causes != '' || bodyData.Genome != ''">
                <div class="title">发病原因</div>
                <div class="stitle" v-if="bodyData.EtiPath != ''">病因</div>
                <div  v-if="bodyData.EtiPath != ''" v-html="bodyData.EtiPath">{{bodyData.EtiPath}}</div>
                <div class="stitle" v-if="bodyData.Causes != ''">诱因</div>
                <div v-if="bodyData.Causes != ''" v-html="bodyData.Causes">{{bodyData.Causes}}</div>
                <div class="stitle" v-if="bodyData.Genome != ''">基因组</div>
                <div v-if="bodyData.Genome != ''" v-html="bodyData.Genome">{{bodyData.Genome}}</div>
            </div>

            <div id="four" class="contentBox" v-if="bodyData.ZSign != '' || bodyData.TSign != '' || bodyData.Complications != ''">
                <div class="title">临床表现</div>
                <div class="stitle" v-if="bodyData.ZSign != ''">症状</div>
                <div v-if="bodyData.ZSign != ''" v-html="bodyData.ZSign">{{bodyData.ZSign}}</div>
                <div class="stitle" v-if="bodyData.TSign != ''">体征</div>
                <div v-if="bodyData.TSign != ''" v-html="bodyData.TSign">{{bodyData.TSign}}</div>
                <div class="stitle" v-if="bodyData.Complications != ''">常见并发症</div>
                <div v-if="bodyData.Complications != ''" v-html="bodyData.Complications">{{bodyData.Complications}}</div>
            </div>

            <div id="five" class="contentBox" v-if="bodyData.Criteria != '' || bodyData.Different != '' || bodyData.FuCheck != ''">
                <div class="title">诊断</div>
                <div class="stitle" v-if="bodyData.Criteria != ''">诊断标准</div>
                <div v-if="bodyData.Criteria != ''" v-html="bodyData.Criteria">{{bodyData.Criteria}}</div>
                <div class="stitle" v-if="bodyData.Different != ''">鉴别诊断</div>
                <div v-if="bodyData.Different != ''" v-html="bodyData.Different">{{bodyData.Different}}</div>
                <div class="stitle" v-if="bodyData.FuCheck != ''">辅助检查</div>
                <div v-if="bodyData.FuCheck != ''" v-html="bodyData.FuCheck">{{bodyData.FuCheck}}</div>
            </div>

            <div id="six" class="contentBox" v-if="bodyData.Drugs != '' || bodyData.Surgery != '' || bodyData.Other != '' || bodyData.CtCure != ''">
                <div class="title">治疗</div>
                <div class="stitle" v-if="bodyData.Drugs != ''">药物</div>
                <div v-if="bodyData.Drugs != ''" v-html="bodyData.Drugs">{{bodyData.Drugs}}</div>
                <div class="stitle" v-if="bodyData.Surgery != ''">手术</div>
                <div v-if="bodyData.Surgery != ''" v-html="bodyData.Surgery">{{bodyData.Surgery}}</div>
                <div class="stitle" v-if="bodyData.Other != ''">其他治疗</div>
                <div v-if="bodyData.Other != ''" v-html="bodyData.Other">{{bodyData.Other}}</div>
                <div class="stitle" v-if="bodyData.CtCure != ''">传统医学</div>
                <div v-if="bodyData.CtCure != ''" v-html="bodyData.CtCure">{{bodyData.CtCure}}</div>
            </div>

            <div id="seven" class="contentBox" v-if="bodyData.Care != '' || bodyData.Prevention != '' || bodyData.Diet != ''">
                <div class="title">预防与护理</div>
                <div class="stitle" v-if="bodyData.Care != ''">护理要点</div>
                <div v-if="bodyData.Care != ''" v-html="bodyData.Care">{{bodyData.Care}}</div>
                <div class="stitle" v-if="bodyData.Prevention != ''">预防方法</div>
                <div v-if="bodyData.Prevention != ''" v-html="bodyData.Prevention">{{bodyData.Prevention}}</div>
                <div class="stitle" v-if="bodyData.Diet != ''">相关饮食</div>
                <div v-if="bodyData.Diet != ''" v-html="bodyData.Diet">{{bodyData.Diet}}</div>
            </div>

            <div id="eight" class="contentBox" v-if="bodyData.Statistics != '' || bodyData.HistoryDevelopment != '' || bodyData.NewResearch != ''">
                <div class="title">最新发展</div>
                <div class="stitle" v-if="bodyData.Statistics != ''">统计数据</div>
                <div v-if="bodyData.Statistics != ''" v-html="bodyData.Statistics">{{bodyData.Statistics}}</div>
                <div class="stitle" v-if="bodyData.HistoryDevelopment != ''">历史发展</div>
                <div v-if="bodyData.HistoryDevelopment != ''" v-html="bodyData.HistoryDevelopment">{{bodyData.HistoryDevelopment}}</div>
                <div class="stitle" v-if="bodyData.NewResearch != ''">最新研究</div>
                <div v-if="bodyData.NewResearch != ''" v-html="bodyData.NewResearch">{{bodyData.NewResearch}}</div>
            </div>

            <div id="nine" class="reference">
                <div class="referenceTitle">参考书目：</div>
                <div v-html="bodyData.RelevantLiterature" class="referenceList"></div>
            </div>
        </div>
        <div class="content" v-if="type == 'd'">
             <div class="contentBox">
                <div class="title" v-html="bodyData.Name">{{bodyData.Name}}</div>
                <div class="stitle">名词解释</div>
                <div v-html="bodyData.Interpretation"></div>
                <!-- <template is="wxParse" data="{{wxParseData:Interpretation.nodes}}" /> -->
            </div>
            <div class="reference">
                <div class="referenceTitle">参考书目：</div>
                <!-- <rich-text nodes="{{bodyData.Resources}}" class="referenceList"></rich-text> -->
                <div v-html="bodyData.Resources" class="referenceList"></div>
            </div> 
        </div>
    </div>
</template>

<script>
import axios from 'axios';
var wx = require("weixin-js-sdk");
export default {
    data () {
        return {
            token: '',
            id: '',
            type: '',
            medData: {},
            bodyData: {},
            searchKey: '',
            requestLink: ''
        }
    },
    methods: {
        back(){
            // var that = this,
            //     index = ''
            // switch (that.type) {
            //     case 'med': index = 1
            //         break;
            //     case 'i': index = 2
            //         break;
            // }
            // this.$router.push({
            //     path: '/phonePage',
            //     query: {
            //         index: index,
            //         searchKey: that.searchKey
            //     }
            // })
            this.$router.back(-1)
        },
        getArticle (id, atype) {
            var that = this,
                token = that.token,
                get_url = '',
                shareTitle = '',
                data = {};
            if (atype == 'ipa' || atype == 'a') {
                get_url = 'https://drplus.lotusdata.com/v1/medsearch/article/' + id;
            } else if (atype == 'q') {
                get_url = 'https://drplus.lotusdata.com/v1/medsearch/question/' + id;
            } else if (atype == 'i') {
                get_url = 'https://drplus.lotusdata.com/v1/medsearch/icdten/' + id;
            } else if (atype == 'd') {
                get_url = 'https://drplus.lotusdata.com/v1/medsearch/dictionary/' + id;
            } else if (atype == 'med') {
                get_url = 'https://so.lotusdata.com/search/?query=' + id + '&type=all_drug_instructions_id';
            } else {
                get_url = 'https://drplus.lotusdata.com/v1/medsearch/itemdetail?id=' + id + '&stype=' + atype;
            }
            axios.get(get_url,{ headers: { Authorization: token} }).then(function (res) {
                if (res.data.code == '0' || res.status == 200) {
                    if (atype == 'ipa' || atype == 'a') {
                        var list = res.data.data;
                    } else if (atype == 'q') {
                        var list = res.data.data;
                    } else if (atype == 'i') {
                        var list = res.data.data;
                        shareTitle = list.IcdName;
                    } else if (atype == 'd') {
                        var list = res.data.data;
                    } else if (atype == 'disease') {
                        var list = res.data.data;
                    } else if (atype == 'med') {
                        var list = res.data[0]._source;
                        shareTitle = list.type2
                    }
                    if (atype == 'med') {
                        for (let i in list) {
                            list[i] = (list[i] + '').replace(/【/gi, '<br/>【');
                            if (list[i].slice(0, 5) == '<br/>') {
                                list[i] = list[i].slice(5);
                            }
                        }
                        that.medData = list
                        that.getKeywords(list)
                    } else if ((atype == 'ipa' || atype == 'a') && list.Content.slice(0, 2) == '[{') {
                        list.drplus = true;
                        if (list.Dtype == 0) {
                            var content = list.Content
                        } else if (list.Dtype == 1) {
                        }
                    } else {
                        var arr = [];
                        for (let v in list) {
                            if (typeof (list[v]) == 'string') {
                                var content = that.initHtml(list[v]);
                                if (content == '无' || content == '') {
                                    list[v] = '';
                                    continue;
                                }
                                list[v] = list[v].replace(/\sstyle=\".*?\"/g, '')
                                list[v] = list[v].replace(/\ssize=\".*?\"/g, '')
                                list[v] = list[v].replace(/<\/?section>/g, '')
                                list[v] = list[v].replace(/img/g, 'img style="width: 100%;"')
                                list[v] = list[v].replace(/font/g, 'p')
                            }
                        }
                        list.drplus = false;
                        that.bodyData = list
                         that.getKeywords(list)
                    }

                } else if (res.data.code == '-2') {
                    that.refreshToken();
                }else{
                    this.$router.go(0)
                }
            })
        },
        refreshToken(){
            var data = {
                "token": this.token.slice(4)
            }
            axios.post('https://api.lotusdata.com/v1/buser/refreshtoken',data,{}).then( res => {
                if(res.data.code == 0){
                    var token = 'JWT '+ res.data.data;
                    this.token = token;
                    localStorage.setItem('vToken',token)
                    this.getArticle(this.id,this.type);
                }
            })
        },
        initHtml (content) {
            var content = content.replace(/<[^>]+>/g, "")
            content = content.replace(/[ | ]*\n/g, '\n'); //去除行尾空白  
            content = content.replace(/\n[\s| | ]*\r/g, '\n'); //去除多余空行
            content = content.replace(/ /ig, '');//去掉  
            content = content.replace(/&nbsp;/ig, '')//去掉nb空格
            content = content.replace(/\n/g, '')
            return content
        },
        getToken(){
            var data = {
                    username: "kevin.li@yitushijie.com",
                    password: "123123",
                    refreshtoken: "0"
                }
                axios.post('https://api.lotusdata.com/v1/buser/token',data,'').then( res => {
                    this.token = "JWT " + res.data.token;
                    localStorage.setItem('vToken',"JWT " + res.data.token);
                    this.getArticle(this.id,this.type);
                })
        },
        getKeywords (list) {
            var that = this,
                atype = that.type,
                id = that.id,
                url = 'https://api.lotusdata.com/v1/search/itemdetail/keywords?stype=' + atype + '&id=' + id,
                data = {},
                shieldWord = list.Name ? list.Name : (list.IcdName ? list.IcdName : '');
            axios.get(url, { headers: { Authorization: that.token} }).then(function (res) {
                console.log(res.data)
                if (res.data.code == '0') {
                    if (res.data.data != null && res.data.data.length != 0) {
                        var keyList = res.data.data;
                        for (var i = 0; i < keyList.length; i++) {
                            if (keyList[i].name == shieldWord) {
                                continue;
                            }
                            var re = new RegExp(keyList[i].name, 'i');
                            for (var prop in list) {
                                if (typeof (list[prop]) == 'string') {
                                    var type = '';
                                    switch (keyList[i].index) {
                                        case 'question': type = 'q'; break;
                                        case 'illness_icdten': type = 'i'; break;
                                        case 'commondisease': type = 'disease'; break;
                                        case 'dictionary': type = 'd'; break;
                                        case 'source_material': type = 'a'; break;
                                        case 'doctor_material': type = 'a'; break;
                                        case 'drug_instructions': type = 'med'; break;
                                        default: console.log('类型错误', 'none'); return;
                                    }
                                    list[prop] = list[prop].replace(re,'<a href="./ill?id='+ keyList[i].ids +'&type=' + type + '" style="color: #fbb53c;">' + keyList[i].name + '</a>');
                                }
                            }
                        }
                    }
                } else {
                console.log('关键词获取失败')
                }
            },
            function (err) {
                common.hideLoading()
                console.log('关键词获取失败')
            })
        },
    },
    mounted () {
        var href = window.location.href.split("#")[0];
        this.requestLink = href;
        this.token = localStorage.getItem('vToken')
        this.searchKey = this.$route.query.searchKey
        this.type = this.$route.query.type
        this.id = this.$route.query.id
        if (this.token) {this.getArticle(this.id,this.type)}
        else {this.getToken()}
    }
}
</script>
<style scoped lang='less'>
    .wrapper {
        height: 100%;
        width: 100%;
        overflow: auto;
        font-size: 14px;
        background-color: #f6f6f6;
        .nav {
            width: 100%;
            height: 50px;
            line-height: 50px;
            text-align: center;
            background-color: #495060;
            position: fixed;
            top: 0;
            z-index: 20;
            color: #fff;
            font-size: 18px;
            img{
                width: 30px;
                height: 30px;
                transform: rotate(180deg);
                position: absolute;
                left: 10px;
                top: 10px;
            }
        }
        .content {
            width: 900px;
            margin: 0 auto;
            margin-top: 50px;
            background-color: #fff;
            box-shadow: 0 1px 3px rgba(26,26,26,.1);
            .btitle{
                width: 100%;
                text-align: center;
                margin: 10px 0;
                font-size: 20px;
            }
            .contentBox{
                margin: 10px 10px;
                padding: 10px;
                border-radius: 10px;
                background-color: #fff;
            }
            .stitle{
                margin-top: 10px;
                font-size: 16px;
                font-weight: bold
            }
            .title {
                width: 100%;
                text-align: center;
                font-size: 18px;
            }
            .reference {
                padding: 10px;
                width: 100%;
                background-color: #495060;
                color: #fff;
                .referenceTitle{
                    font-size: 20px;
                    font-weight: bold;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/pcpage/illPage.vue